module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Type</span></div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 nopadding-r\">\r\n        <select name=\"type\" id=\"type\">\r\n            <option value=\"text\">Text</option>\r\n            <option value=\"number\">Number</option>\r\n            <option value=\"day\">Day</option>\r\n            <option value=\"month\">Month</option>\r\n            <option value=\"week\">Week</option>\r\n            <option value=\"year\">Year</option>\r\n            <option value=\"time\">Time</option>\r\n            <option value=\"daysAgo\">Days Ago</option>\r\n            <option value=\"weeksAgo\">Weeks Ago</option>\r\n            <option value=\"monthsAgo\">Months Ago</option>\r\n            <option value=\"yearsAgo\">Years Ago</option>\r\n            <option value=\"minutesAgo\">Minutes Ago</option>\r\n            <option value=\"hoursAgo\">Hours Ago</option>\r\n        </select>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 nopadding-r\">\r\n        <select name=\"operator\" id=\"operator\">\r\n            <option value=\"equal\">Equal</option>\r\n            <option value=\"like\">Wildcard</option>\r\n            <option value=\"lessThan\">Less</option>\r\n            <option value=\"lessOrEqual\">Less Or Equal</option>\r\n            <option value=\"greaterThan\">Greater</option>\r\n            <option value=\"greaterOrEqual\">Greater Or Equal</option>\r\n            <option value=\"notEqual\">Not Equal</option>\r\n            <option value=\"range\">Range</option>\r\n        </select>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}